<template>
    <div class="product" >
        <a :href="card.slug" target="_self"
                     :title="card.name" class="product__wrapper"
                     @click="onSelectItem">
            <div class="product__image_wrapper" itemscope="" itemtype="http://schema.org/ImageObject">
                <div v-if="showPreorder" class="preorder">
                    <span>{{ trans("Pre-order") }}</span>
                </div>
                <meta itemprop="name" :content="card.name">
                <meta itemprop="description"
                      :content="card.description">
                <picture class="product__image product__first-image lazy-load">
                    <img :src="card.img_first.webp"
                         :alt="card.name" class="product__image product__first-image "
                         itemprop="contentUrl" style="display: block;">
                </picture>
                <picture class="product__image product__second-image lazy-load">
                    <img :src="card.img_last.webp"
                         :alt="card.name" class="product__image product__second-image "
                         style="display: block;">
                </picture>
                <span v-if="this.$store.state.settings.user?.role_id >= 500" @click.prevent="updateSort(card)" class="add-likes order-icon" title="Изменить сортировку"> 📊 {{ card.sort }}</span>
                <span @click.prevent="updateLike(card)" :class="card.favourites ? 'active-like' : '' " class="add-like">
                            <svg class="svg-icon" width="22" height="18" viewBox="0 0 22 18" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11 17.25C11 17.25 1.625 12 1.625 5.62501C1.625 4.49803 2.01546 3.40585 2.72996 2.53431C3.44445 1.66277 4.43884 1.0657 5.54393 0.844677C6.64903 0.623658 7.79657 0.792346 8.79131 1.32204C9.78605 1.85174 10.5665 2.70972 11 3.75001V3.75001C11.4335 2.70972 12.2139 1.85174 13.2087 1.32204C14.2034 0.792346 15.351 0.623658 16.4561 0.844677C17.5612 1.0657 18.5555 1.66277 19.27 2.53431C19.9845 3.40585 20.375 4.49803 20.375 5.62501C20.375 12 11 17.25 11 17.25Z"
                                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                </path>
                            </svg>
                        </span>
            </div>
            <div class="product__info">
                <h3 class="product__title">
                    <span class="product__title-link">{{ card.name }}</span>
                </h3>
                <div class="product__price-row">

                    <template v-if="card.offer.price_old_str">
                        <p class="product__sale-price product__text-def">
                            <span v-if="card.isPricesDifferent">от </span>
                            {{ card.offer.price_str }} {{ card.signs }}
                        </p>
                        <p class="product__old-price"> {{ card.offer.price_old_str }} {{ card.signs }}</p>
                    </template>

                    <p class="product__main-price product__text-def" v-if="!card.offer.price_old_str">
                        <span v-if="card.isPricesDifferent">от </span> {{ card.offer.price_str }} {{ card.signs }}
                    </p>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import { selectItem } from '../services/ga4Ecommerce.js'

export default {
    name: "product-card",
    props: {
        card: {
            type: Object,
            required: true,
        },
        itemListId: {
            type: String,
            default: '',
        },
        itemListName: {
            type: String,
            default: '',
        },
        index: {
            type: Number,
            default: 1,
        },
    },
    mounted() {
        this.checkLike()
    },
    computed: {
        showPreorder() {
            return (this.card.preorder_ru && this.$store.state.settings.site_id === 1) || (this.card.preorder_world && this.$store.state.settings.site_id === 2)
        },
    },
    methods:{
        async updateSort(card) {
            let prompts = prompt("Введите что-нибудь:",card.sort)
            // console.log(card)
            // let inputValue;
            // inputValue = card.sort
            //
            // const { value: dataSort } = await Swal.fire({
            //     title: "Изменить сортировку",
            //     input: "number",
            //     inputLabel: "" ,
            //     inputValue ,
            //     showCancelButton: true,
            //     inputValidator: (value) => {
            //         if (!value) {
            //             return "You need to write something!";
            //         }
            //     }
            // });
            // if (dataSort) {
            //     card.sort = dataSort
            //     await this.$parent.getCards(card)
            // }
            card.sort = prompts
            await this.$parent.getCards(card)
        },
        checkLike() {
            if (this.$store.state.settings.basket.favourites.find(it => it.card_id == this.card.id)) {
                this.card.favourites = true
            }
        },
        updateLike(card){
            card.favourites = !card.favourites
            this.$parent.$parent.$refs.header.updateLike(card)
        },
        onSelectItem() {
            selectItem(this.card, this.itemListId, this.itemListName, this.index)
        },
    }
}
</script>

<style scoped>
.product__image_wrapper {
    position: relative;
}
</style>
